import { useNavigate } from "react-router-dom";
import { logout } from "../../redux/auth/actions";
import { useEffect, useRef, useState } from "react";
import storePersist from "../../redux/storePersist";
import { useSelector } from "react-redux";
import { selectCurrent } from "../../redux/settings/selectors";
import { useAppDispatch } from "../../hooks/hooks";
import { settings } from "../../redux/settings/actions";
import { selectOrganizationUnitsListItems } from "../../redux/organizationUnits/selector";


const Sidebar = () => {
  let items: any = []
  let subitems: any = []
  let menuitems: any = []
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const result = useSelector(selectCurrent)
  const [color, setColor] = useState('universal')
  const [logo, setLogo] = useState<any>()
  const organizationLists = useSelector(selectOrganizationUnitsListItems)
  const { sidebar, theme } = result
  const [open, setOpen] = useState(items)
  const [isMore, setIsMore] = useState(false)
  const [subOpen, setSubOpen] = useState(subitems)
  const [menuOpen, setMenuOpen] = useState(menuitems)
  const [activeIndex, setActiveIndex] = useState(null);
  const [activeSubIndex, setActiveSubIndex] = useState(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [menus, setMenus] = useState([
    {
      id: `main-menu-2-all`,
      path: '/web-platform/websites',
      label: 'Websites Template Management',
      isEnabled: true,
      svg: (

        <svg viewBox="0 0 68.064 68.064" xmlns="http://www.w3.org/2000/svg" width="20" height="20" stroke="currentColor" stroke-width="2" fill="none">
          <path d="m 34.064,0 c -18.79523,0 -34.03178,15.2366 -34.03178,34.0318 0,18.7953 15.23655,34.0318 34.03178,34.0318 18.79523,0 34.03178,-15.2365 34.03178,-34.0318 0,-18.7952 -15.23655,-34.0318 -34.03178,-34.0318 z m 0,4.0038 c 8.22836,0 15.65838,3.335 21.08218,8.6956 -2.2925,-0.4445 -4.64842,-0.6881 -7.0691,-0.6881 -0.65645,0 -1.29102,-0.034 -1.93931,0 -5.07362,0.2639 -9.90353,1.5774 -14.26332,3.6909 -3.0054,-3.0263 -5.95314,-6.2441 -8.88329,-9.5714 3.42421,-1.3581 7.16515,-2.127 11.07284,-2.127 z m -15.51449,4.3165 c 2.88754,3.5092 5.88948,6.7767 8.94585,9.9468 -3.22457,2.1437 -6.11513,4.7411 -8.5705,7.7572 -0.2955,-0.026 -0.5735,0 -0.87582,0 -0.83047,0 -1.60564,0.1222 -2.37722,0.3128 -1.48094,-2.9777 -2.64006,-6.1541 -3.44071,-9.4463 -0.24263,-0.9976 -0.34725,-1.9902 -0.37535,-3.0028 1.95534,-2.1544 4.19085,-4.0537 6.69375,-5.5677 z m 36.59667,7.2568 c 0.9368,0.016 1.82847,0.1593 2.75257,0.3128 3.85106,5.0488 6.19329,11.3019 6.19329,18.1419 0,3.0884 -0.51034,6.0793 -1.37628,8.8833 -1.84351,-1.5051 -3.66531,-3.0469 -5.50515,-4.5667 0.54763,-0.9986 0.87582,-2.0964 0.87582,-3.3156 0,-3.8697 -3.13693,-7.0066 -7.00654,-7.0066 -1.63435,0 -3.12472,0.5634 -4.31653,1.5014 -3.08817,-2.6927 -6.15347,-5.4453 -9.19609,-8.3202 4.90568,-2.7341 10.2584,-4.6708 15.82728,-5.5052 0.58008,-0.087 1.17251,-0.1345 1.75163,-0.1251 z m -46.73113,2.8777 c 0.37234,2.4024 0.92538,5.6885 1.06349,6.1307 0.45076,1.4432 0.95153,2.8561 1.56396,4.254 -1.84811,1.816 -3.0028,4.3985 -3.0028,7.1942 0,2.7159 1.12168,5.1407 2.87768,6.944 -0.53504,2.6082 -0.87582,5.3002 -0.87582,8.07 0,0.3118 -0.008,0.6284 0,0.9384 -3.75572,-5.0134 -6.0056,-11.2081 -6.0056,-17.9543 0,-5.7104 1.6118,-11.0319 4.37909,-15.577 z m 24.77313,5.5051 c 3.59512,3.4403 7.28686,6.7005 11.01028,9.8843 -0.0645,0.3818 -0.12512,0.7883 -0.12512,1.1886 0,3.8696 3.13693,7.0065 7.00655,7.0065 0.82747,0 1.64027,-0.1746 2.37722,-0.4379 2.44526,1.9839 4.9266,3.9783 7.38189,5.943 -0.53766,1.0644 -1.09564,2.0784 -1.75164,3.0654 -1.63769,0.2812 -3.3281,0.5226 -3.94118,0.563 -3.44457,0.2269 -6.90336,-0.1541 -10.25958,-0.9383 -0.40047,-3.4892 -3.34754,-6.1933 -6.94398,-6.1933 -1.68555,0 -3.23282,0.5722 -4.44165,1.5639 -2.35057,-1.3976 -4.60041,-3.0449 -6.69375,-4.8795 0.76207,-1.4124 1.25117,-2.9745 1.25117,-4.6919 0,-2.2769 -0.78391,-4.3864 -2.06443,-6.0682 2.17053,-2.2216 4.61481,-4.2004 7.19422,-6.0056 z m -10.44726,20.832 c 2.51886,2.2283 5.31248,4.1369 8.25771,5.7553 -0.012,0.1658 -0.0625,0.3317 -0.0625,0.5005 0,3.8696 3.13693,7.0066 7.00655,7.0066 2.37063,0 4.48751,-1.201 5.75537,-3.0029 2.92623,0.4984 5.96079,0.6684 9.00841,0.438 0.91708,-0.069 1.80277,-0.1886 2.69002,-0.3754 -5.44357,5.5077 -12.97676,8.9459 -21.33242,8.9459 -7.22423,0 -13.83699,-2.5684 -19.01776,-6.8189 -0.53088,-1.2947 -1.05915,-2.6194 -1.00094,-3.1905 0.28501,-2.7964 0.98246,-5.5772 1.93931,-8.2577 0.67005,0.1413 1.35231,0.2502 2.06443,0.2502 1.7123,0 3.28251,-0.4933 4.69188,-1.2511 z" transform="translate(0 0)" />
        </svg>
      ),

      Description: 'eAdvisor is a enterprise dashboard and reports to visualize key metrics and data in one centralized location, allowing you to monitor and analyze information at a glance. Use our comprehensive reports to uncover trends, identify opportunities, and drive growth.',
      subMenu: [
        {
          id: `coln-1-collections`,
          label: 'Templates',
          path: '/web-platform/websites',
          isEnabled: true,
          svg: (
            <svg viewBox="0 0 68.064 68.064" xmlns="http://www.w3.org/2000/svg" width="18" height="18" stroke="currentColor" stroke-width="2" fill="none">
              <path d="m 34.064,0 c -18.79523,0 -34.03178,15.2366 -34.03178,34.0318 0,18.7953 15.23655,34.0318 34.03178,34.0318 18.79523,0 34.03178,-15.2365 34.03178,-34.0318 0,-18.7952 -15.23655,-34.0318 -34.03178,-34.0318 z m 0,4.0038 c 8.22836,0 15.65838,3.335 21.08218,8.6956 -2.2925,-0.4445 -4.64842,-0.6881 -7.0691,-0.6881 -0.65645,0 -1.29102,-0.034 -1.93931,0 -5.07362,0.2639 -9.90353,1.5774 -14.26332,3.6909 -3.0054,-3.0263 -5.95314,-6.2441 -8.88329,-9.5714 3.42421,-1.3581 7.16515,-2.127 11.07284,-2.127 z m -15.51449,4.3165 c 2.88754,3.5092 5.88948,6.7767 8.94585,9.9468 -3.22457,2.1437 -6.11513,4.7411 -8.5705,7.7572 -0.2955,-0.026 -0.5735,0 -0.87582,0 -0.83047,0 -1.60564,0.1222 -2.37722,0.3128 -1.48094,-2.9777 -2.64006,-6.1541 -3.44071,-9.4463 -0.24263,-0.9976 -0.34725,-1.9902 -0.37535,-3.0028 1.95534,-2.1544 4.19085,-4.0537 6.69375,-5.5677 z m 36.59667,7.2568 c 0.9368,0.016 1.82847,0.1593 2.75257,0.3128 3.85106,5.0488 6.19329,11.3019 6.19329,18.1419 0,3.0884 -0.51034,6.0793 -1.37628,8.8833 -1.84351,-1.5051 -3.66531,-3.0469 -5.50515,-4.5667 0.54763,-0.9986 0.87582,-2.0964 0.87582,-3.3156 0,-3.8697 -3.13693,-7.0066 -7.00654,-7.0066 -1.63435,0 -3.12472,0.5634 -4.31653,1.5014 -3.08817,-2.6927 -6.15347,-5.4453 -9.19609,-8.3202 4.90568,-2.7341 10.2584,-4.6708 15.82728,-5.5052 0.58008,-0.087 1.17251,-0.1345 1.75163,-0.1251 z m -46.73113,2.8777 c 0.37234,2.4024 0.92538,5.6885 1.06349,6.1307 0.45076,1.4432 0.95153,2.8561 1.56396,4.254 -1.84811,1.816 -3.0028,4.3985 -3.0028,7.1942 0,2.7159 1.12168,5.1407 2.87768,6.944 -0.53504,2.6082 -0.87582,5.3002 -0.87582,8.07 0,0.3118 -0.008,0.6284 0,0.9384 -3.75572,-5.0134 -6.0056,-11.2081 -6.0056,-17.9543 0,-5.7104 1.6118,-11.0319 4.37909,-15.577 z m 24.77313,5.5051 c 3.59512,3.4403 7.28686,6.7005 11.01028,9.8843 -0.0645,0.3818 -0.12512,0.7883 -0.12512,1.1886 0,3.8696 3.13693,7.0065 7.00655,7.0065 0.82747,0 1.64027,-0.1746 2.37722,-0.4379 2.44526,1.9839 4.9266,3.9783 7.38189,5.943 -0.53766,1.0644 -1.09564,2.0784 -1.75164,3.0654 -1.63769,0.2812 -3.3281,0.5226 -3.94118,0.563 -3.44457,0.2269 -6.90336,-0.1541 -10.25958,-0.9383 -0.40047,-3.4892 -3.34754,-6.1933 -6.94398,-6.1933 -1.68555,0 -3.23282,0.5722 -4.44165,1.5639 -2.35057,-1.3976 -4.60041,-3.0449 -6.69375,-4.8795 0.76207,-1.4124 1.25117,-2.9745 1.25117,-4.6919 0,-2.2769 -0.78391,-4.3864 -2.06443,-6.0682 2.17053,-2.2216 4.61481,-4.2004 7.19422,-6.0056 z m -10.44726,20.832 c 2.51886,2.2283 5.31248,4.1369 8.25771,5.7553 -0.012,0.1658 -0.0625,0.3317 -0.0625,0.5005 0,3.8696 3.13693,7.0066 7.00655,7.0066 2.37063,0 4.48751,-1.201 5.75537,-3.0029 2.92623,0.4984 5.96079,0.6684 9.00841,0.438 0.91708,-0.069 1.80277,-0.1886 2.69002,-0.3754 -5.44357,5.5077 -12.97676,8.9459 -21.33242,8.9459 -7.22423,0 -13.83699,-2.5684 -19.01776,-6.8189 -0.53088,-1.2947 -1.05915,-2.6194 -1.00094,-3.1905 0.28501,-2.7964 0.98246,-5.5772 1.93931,-8.2577 0.67005,0.1413 1.35231,0.2502 2.06443,0.2502 1.7123,0 3.28251,-0.4933 4.69188,-1.2511 z" transform="translate(0 0)" />
            </svg>

          ),
        },
        {
          id: `coln-1-collections`,
          label: 'Pages',
          path: '/web-platform/Pages',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" xmlns="http://www.w3.org/2000/svg" width="12" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 9H2V7H22V9H9V22H7V9ZM3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3C0 1.34315 1.34315 0 3 0ZM3 2C2.44772 2 2 2.44772 2 3V21C2 21.5523 2.44772 22 3 22H21C21.5523 22 22 21.5523 22 21V3C22 2.44772 21.5523 2 21 2H3Z" />
            </svg>
          ),
        },
        {
          id: `coln-1-collections`,
          label: 'Layouts',
          path: '/web-platform/layouts',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" xmlns="http://www.w3.org/2000/svg" width="12" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 9H2V7H22V9H9V22H7V9ZM3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3C0 1.34315 1.34315 0 3 0ZM3 2C2.44772 2 2 2.44772 2 3V21C2 21.5523 2.44772 22 3 22H21C21.5523 22 22 21.5523 22 21V3C22 2.44772 21.5523 2 21 2H3Z" />
            </svg>

          ),
        },
        {
          id: `coln-1-collections`,
          label: 'Cards',
          path: '/web-platform/cards',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h13v13H3z M8 21v-5H3v8h13v-5h5v-8h-5v5h-5v5H8z" />
            </svg>

          ),
        },
        {
          id: `coln-1-collections`,
          label: 'Card Type',
          path: '/web-platform/card-types',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h13v13H3z M8 21v-5H3v8h13v-5h5v-8h-5v5h-5v5H8z" />
            </svg>

          ),
        },
      ],
    },
    {
      id: `main-menu-2-all`,
      path: '/web-platform/websites',
      label: 'Tenant Websites Management',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 mr-1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 24 24">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12.25 12.5C12.25 13.6046 11.3546 14.5 10.25 14.5C9.14543 14.5 8.25 13.6046 8.25 12.5C8.25 11.3954 9.14543 10.5 10.25 10.5C11.3546 10.5 12.25 11.3954 12.25 12.5Z M14.25 4.5L20 10.1893V18H16.5V20H4V11.9393L10.25 5.68933L11.625 7.06433L14.25 4.5Z M18.5 10.8107V16.5H16.5V11.9393L12.6857 8.12499L14.25 6.56065L18.5 10.8107Z M5.5 12.5607V18.5H6.78545C7.02806 16.8038 8.48677 15.5 10.25 15.5C12.0132 15.5 13.4719 16.8038 13.7146 18.5H15V12.5607L10.25 7.81065L5.5 12.5607Z" />
        </svg>
      ),

      Description: 'eAdvisor is a enterprise dashboard and reports to visualize key metrics and data in one centralized location, allowing you to monitor and analyze information at a glance. Use our comprehensive reports to uncover trends, identify opportunities, and drive growth.',
      subMenu: [
        {
          id: `coln-1-collections`,
          label: 'Tenant ',
          path: '/web-platform/platform-management/tenants',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12.25 12.5C12.25 13.6046 11.3546 14.5 10.25 14.5C9.14543 14.5 8.25 13.6046 8.25 12.5C8.25 11.3954 9.14543 10.5 10.25 10.5C11.3546 10.5 12.25 11.3954 12.25 12.5Z M14.25 4.5L20 10.1893V18H16.5V20H4V11.9393L10.25 5.68933L11.625 7.06433L14.25 4.5Z M18.5 10.8107V16.5H16.5V11.9393L12.6857 8.12499L14.25 6.56065L18.5 10.8107Z M5.5 12.5607V18.5H6.78545C7.02806 16.8038 8.48677 15.5 10.25 15.5C12.0132 15.5 13.4719 16.8038 13.7146 18.5H15V12.5607L10.25 7.81065L5.5 12.5607Z" />
            </svg>
          ),
        },

      ],
    },
    {
      id: `main-menu-2-all`,
      path: '/web-platform/websites',
      label: 'Account Websites Management',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 mr-1"
          xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778" />
        </svg>

      ),

      Description: 'eAdvisor is a enterprise dashboard and reports to visualize key metrics and data in one centralized location, allowing you to monitor and analyze information at a glance. Use our comprehensive reports to uncover trends, identify opportunities, and drive growth.',
      subMenu: [
        {
          id: `coln-1-collections`,
          label: 'Accounts ',
          path: '/web-platform/websites',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1"
              xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778" />
            </svg>

          ),
        },

      ],
    },
    
  ])
  menus.map((item) => {
    items.push({ open: true, isActive: false })

  })


  const handleClickOutside = (event: MouseEvent) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      let menu = [...open]
      open?.map((obj: any, idx: any) => {
        // menu[idx].isActive = false
        menu[idx].open = true
      })
      setOpen(menu)
      let menu1 = [...subOpen]
      subOpen?.map((obj: any, idx: any) => {
        // menu1[idx].isActive = false
        menu1[idx].open = true
      })
      setSubOpen(menu1)
      let menu2 = [...menuitems]
      menuitems?.map((obj: any, idx: any) => {
        // menu2[idx].isActive = false
        menu2[idx].open = true
      })
      setMenuOpen(menu2)
    }
  };

  const handleItemClick = (index: any) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  const handleSubItemClick = (index: any) => {
    setActiveSubIndex(index === activeSubIndex ? null : index);
  };

  const handleSideBarView = () => {
    dispatch(settings.set({ sidebar: !sidebar }))
  }

  const fetchLogo = () => {

    const storeData = {
      logoDark: organizationLists?.result?.items[0]?.BrandMappings[0]?.Configurations?.Logos.filter((logo: any) => {
        return logo.Background === 'Light'
      }),
      logoLight: organizationLists?.result?.items[0]?.BrandMappings[0]?.Configurations?.Logos.filter((logo: any) => {
        return logo.Background === 'Dark'
      }),
      storeName: organizationLists?.result?.items[0]?.BrandMappings[0]?.Name,
      description: organizationLists?.result?.items[0]?.BrandMappings[0]?.Description,
      favicon: organizationLists?.result?.items[0]?.BrandMappings[0]?.Configurations?.Favicons[0]?.Url || '/assets/images/logo.png'
    }
    setLogo(storeData)
  }
  useEffect(() => {
    if (storePersist?.get("organizationUnits")?.isSuccess) {
      fetchLogo()
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };

  }, [])

  const handleNavigate = (data: any) => {
    navigate(`${data}`)
  }

  const handleMenu = (index: any, index1: any) => {
    let menu = [...open]
    open?.map((obj: any, idx: any) => {
      if (idx == index) {
        menu[idx].open = !obj.open
        menu[idx].isActive = true
      }
      else {
        menu[idx].open = true
        menu[idx].isActive = false
      }
    })
    setOpen(menu)
  }
  const handleSubMenu = (e: any, index: any) => {
    e.stopPropagation()
    let menu = [...subOpen]
    subOpen?.map((obj: any, idx: any) => {
      if (idx == index) {
        menu[idx].open = !obj.open
        menu[idx].isActive = true
      }
      else {
        menu[idx].open = true
        menu[idx].isActive = false
      }
    })
    setSubOpen(menu)
  }
  const handleItems = (e: any, itemIndex: any) => {
    e.stopPropagation()
    let menu2 = [...menuitems]
    menuitems?.map((obj: any, idx: any) => {
      if (idx == itemIndex) {
        menu2[idx].isActive = true
        menu2[idx].open = !obj.open
      }
      else {
        menu2[idx].isActive = false
        menu2[idx].open = true
      }
    })
    setMenuOpen(menu2)
  }

  const beginWord = (sentence: string | undefined | null) => {
    if (!sentence || typeof sentence !== 'string') {
      return '';
    }
    const words = sentence.trim().split(/\s+/);
    if (words.length === 0) {
      return '';
    }
    if (sentence.length > 19) {
      const lastWord = words.pop() as string;
      let transformedSentence = ""
      if (words.length == 1) {
        transformedSentence = `${words[0]} `;
      }
      else if (words.length == 2)
        transformedSentence = `${words[0]} ${words[1]}`;
      return transformedSentence
    }
    else {
      return sentence
    }
  }

  const endWord = (sentence: string | undefined | null) => {
    if (!sentence || typeof sentence !== 'string') {
      return '';
    }
    const words = sentence.trim().split(/\s+/);
    if (words.length === 0) {
      return '';
    }
    if (sentence.length > 19) {
      const lastWord = words.pop() as string;
      return lastWord
    }
  }


  return (
    <>
      {sidebar ? <div className={`w-64 fixed md:top-0 md:left-0 h-screen lg:block primary-${color} z-10 `}>

        {sidebar &&
          <div className={`w-full flex flex-col justify-end items-end p-2 pr-4 mt-20 lg:mt-20 md:mt-20`}>
            <svg
              onClick={() => dispatch(settings.set({ sidebar: !sidebar }))}
              width="22" height="22" viewBox="0 0 24 24" fill="none" className="cursor-pointer hover:stroke-hilight">
              <title>Show Less Infomation</title>
              <path stroke-width="1.25" d="M12.6772 19.5377C12.9742 19.8265 13.449 19.8198 13.7377 19.5228C14.0265 19.2258 14.0198 18.751 13.7228 18.4623L12.6772 19.5377ZM6 12L5.47719 11.4623C5.33195 11.6035 5.25 11.7974 5.25 12C5.25 12.2026 5.33195 12.3965 5.47719 12.5377L6 12ZM13.7228 5.53775C14.0198 5.24901 14.0265 4.77418 13.7377 4.47719C13.449 4.1802 12.9742 4.17351 12.6772 4.46225L13.7228 5.53775ZM17.4772 18.3708C17.7742 18.6595 18.249 18.6528 18.5378 18.3558C18.8265 18.0588 18.8198 17.584 18.5228 17.2952L17.4772 18.3708ZM12 12L11.4772 11.4622C11.332 11.6035 11.25 11.7974 11.25 12C11.25 12.2026 11.332 12.3965 11.4772 12.5378L12 12ZM18.5228 6.70476C18.8198 6.41603 18.8265 5.9412 18.5378 5.64421C18.249 5.34721 17.7742 5.34051 17.4772 5.62924L18.5228 6.70476ZM13.7228 18.4623L6.52281 11.4623L5.47719 12.5377L12.6772 19.5377L13.7228 18.4623ZM6.52281 12.5377L13.7228 5.53775L12.6772 4.46225L5.47719 11.4623L6.52281 12.5377ZM18.5228 17.2952L12.5228 11.4622L11.4772 12.5378L17.4772 18.3708L18.5228 17.2952ZM12.5228 12.5378L18.5228 6.70476L17.4772 5.62924L11.4772 11.4622L12.5228 12.5378Z" fill="#f8f8f8" />
            </svg>
          </div>
        }
        <div className="h-[calc(100vh-10rem)] overflow-auto">
          <div className="mb-4  px-4 h-max ">
            {menus.map((obj: any, index1: any) => {
              return <li
                onClick={() => handleMenu(index1, null)}
                className={`w-full flex flex-col justify-start space-y-3 `}>
                <div className={`flex flex-row justify-start rounded-r-lg px-2 cursor-pointer h-10 items-center hover:bg-secondary  dark:hover:text-black" ${open[index1]?.isActive ? "border-l-4 border-blue-500" : ""} `}>
                  {obj?.svg}
                  <span onClick={() => handleNavigate(obj?.path)} className="dark:hover:text-black w-36 text-sm ">{obj.label}</span>
                </div>
                {obj?.subMenu?.map((obj1: any, index2: any) => {
                  return <ul
                    onClick={(e) => handleSubMenu(e, index2)}
                    className={`w-full flex pl-2 flex-col justify-center space-y-3 ${open[index1]?.open ? 'hidden' : 'ml-2'} `}>
                    <div className={`flex flex-row justify-start  items-center  rounded-r-lg  px-2 cursor-pointer  h-10 hover:bg-secondary dark:hover:text-black"  ${subOpen[index2]?.isActive ? "border-l-4 border-blue-500" : ""}`}>
                      {obj1?.svg}
                      <div onClick={() => handleNavigate(obj1?.path)} className="primary-${color}  text-sm dark:text-slate-200 dark:hover:text-black w-36  flex flex-col w-auto justify-center items-end">
                        <span className="">{beginWord(obj1.label)}</span>
                        <span className="text-right text-xs italic">{endWord(obj1.label)}</span>
                      </div>
                    </div>
                    {obj1?.subMenu?.map((obj2: any, index3: any) => {
                      return <li
                        onClick={(e) => handleItems(e, index3)}
                        className={`w-full flex flex-col pl-2 justify-start space-y-3  ${subOpen[index2]?.open ? 'hidden' : 'ml-2'} `}>
                        <div className={`flex flex-row justify-start rounded-r-lg px-2 cursor-pointer h-10 items-center hover:bg-secondary dark:hover:text-black"  ${menuOpen[index3]?.isActive ? "border-l-4 border-blue-500" : ""}`}>
                          {obj2?.svg}
                          <div onClick={() => handleNavigate(obj2?.path)} className="text-sm dark:text-slate-200 dark:hover:text-black w-36 flex flex-col w-auto justify-center items-end">
                            <span className="">{beginWord(obj2.label)}</span>
                            <span className="text-right text-xs italic"> {endWord(obj2.label)}</span>
                          </div>
                        </div>
                      </li>
                    })}
                  </ul>
                })}
              </li>
            })}
          </div>
        </div>
      </div> : <div ref={dropdownRef} className={`w-24 fixed md:top-0 md:left-0 h-screen lg:block primary-${color} z-10`} >
        <div className="">
          {!sidebar &&
            <div className={`w-full flex flex-col justify-end items-end p-2 mt-20 lg:mt-20 md:mt-20`}>
              <svg
                onClick={() => dispatch(settings.set({ sidebar: !sidebar }))}
                width="22" height="22" viewBox="0 0 24 24" fill="none" className="cursor-pointer hover:stroke-hilight">
                <title>Show More Infomation</title>
                <path stroke-width="1.25" d="M10.2772 18.4623C9.9802 18.751 9.97351 19.2258 10.2623 19.5228C10.551 19.8198 11.0258 19.8265 11.3228 19.5377L10.2772 18.4623ZM18 12L18.5228 12.5377C18.6681 12.3965 18.75 12.2026 18.75 12C18.75 11.7974 18.6681 11.6035 18.5228 11.4623L18 12ZM11.3228 4.46225C11.0258 4.17351 10.551 4.1802 10.2623 4.47719C9.97351 4.77418 9.9802 5.24901 10.2772 5.53775L11.3228 4.46225ZM5.47721 17.2952C5.18021 17.584 5.17351 18.0588 5.46224 18.3558C5.75097 18.6528 6.2258 18.6595 6.52279 18.3708L5.47721 17.2952ZM12 12L12.5228 12.5378C12.668 12.3965 12.75 12.2026 12.75 12C12.75 11.7974 12.668 11.6035 12.5228 11.4622L12 12ZM6.52279 5.62924C6.2258 5.34051 5.75097 5.34721 5.46224 5.64421C5.17351 5.9412 5.18021 6.41603 5.47721 6.70476L6.52279 5.62924ZM11.3228 19.5377L18.5228 12.5377L17.4772 11.4623L10.2772 18.4623L11.3228 19.5377ZM18.5228 11.4623L11.3228 4.46225L10.2772 5.53775L17.4772 12.5377L18.5228 11.4623ZM6.52279 18.3708L12.5228 12.5378L11.4772 11.4622L5.47721 17.2952L6.52279 18.3708ZM12.5228 11.4622L6.52279 5.62924L5.47721 6.70476L11.4772 12.5378L12.5228 11.4622Z" fill="#f8f8f8" />
              </svg>
            </div>
          }
          <div className="mb-4 px-4 h-max ">
            <ul className="w-full flex flex-col justify-start space-y-3">
              {!isMore && menus.map((barmenu: any, index1: any) => {
                return <li
                  className={`flex items-center h-10 ${open[index1]?.isActive ? "border-l-4 border-blue-500" : ""} ${index1 > 8 ? 'hidden' : ""} `}
                  onClick={() => handleMenu(index1, null)} >
                  <div className={`flex flex-row justify-start  rounded-lg  px-4  cursor-pointer  h-10 items-center hover:bg-secondary  max-w-24   dark:hover:text-black"`}>
                    {barmenu?.svg}
                  </div>
                  <ul className={`flex flex-col space-y-3 items-center  max-h-[300px] max-w-56 overflow-auto justify-start  py-5 px-3  primary-${color} ml-0 ${index1 > 4 ? "mt-[calc(100vh-60rem)]" : "mt-auto"} rounded-r-xl min-w-64  font-medium text-sm  "  ${open[index1]?.open ? 'hidden' : 'ml-4'}`}>
                    {barmenu?.subMenu?.map((obj1: any, index2: any) => {
                      return <ul
                        onClick={(e) => handleSubMenu(e, index2)}
                        className={`w-full flex pl-2 flex-col  justify-center space-y-3 ${open[index1]?.open ? 'hidden' : 'pl-2'} `}>
                        <div className={`flex flex-row justify-start  items-center  rounded-r-lg  px-2 cursor-pointer  h-10 hover:bg-secondary dark:hover:text-black"  ${subOpen[index2]?.isActive ? "border-l-4 border-blue-500" : ""}`}>
                          {obj1?.svg}
                          <div onClick={() => handleNavigate(obj1?.path)} className="primary-${color}  text-sm dark:text-slate-200 dark:hover:text-black   flex flex-col w-auto justify-center items-end">
                            <span className="">{beginWord(obj1.label)}</span>
                            <span className="text-right text-xs italic">{endWord(obj1.label)}</span>
                          </div>
                        </div>
                        {obj1?.subMenu?.map((obj2: any, index3: any) => {
                          return <li
                            onClick={(e) => handleItems(e, index3)}
                            className={`w-full flex flex-col pl-2 justify-start space-y-3  ${subOpen[index2]?.open ? 'hidden' : 'ml-2'} `}>
                            <div className={`flex flex-row justify-start rounded-r-lg px-2 cursor-pointer h-10 items-center hover:bg-secondary dark:hover:text-black"  ${menuOpen[index3]?.isActive ? "border-l-4 border-blue-500" : ""}`}>
                              {obj2?.svg}
                              <div onClick={() => handleNavigate(obj2?.path)} className="text-sm dark:text-slate-200 dark:hover:text-black w-36 flex flex-col w-auto justify-center items-end">

                                <span className="">{beginWord(obj2.label)}</span>
                                <span className="text-right text-xs italic"> {endWord(obj2.label)}</span>
                              </div>
                            </div>
                          </li>
                        })}
                      </ul>
                    })}
                  </ul>
                </li>
              })}
              {isMore && menus.map((barmenu: any, index1: any) => {
                return <li
                  className={`flex items-center h-10 ${open[index1]?.isActive ? "border-l-4 border-blue-500" : ""} ${index1 < 8 ? 'hidden' : ""} `}
                  onClick={() => handleMenu(index1, null)} >
                  <div className={`flex flex-row justify-start  rounded-lg  px-4  cursor-pointer  h-10 items-center hover:bg-secondary  max-w-24   dark:hover:text-black"`}>
                    {barmenu?.svg}
                  </div>
                  <ul className={`flex flex-col space-y-3 items-center  max-h-[300px] max-w-56 overflow-auto justify-start  py-5 px-3  bg-primary dark:bg-slate-800 ml-0 ${index1 > 12 ? "mt-[calc(100vh-60rem)]" : "mt-auto"} rounded-r-xl min-w-64  font-medium text-sm  "  ${open[index1]?.open ? 'hidden' : 'ml-4'}`}>
                    {barmenu?.subMenu?.map((obj1: any, index2: any) => {
                      return <ul
                        onClick={(e) => handleSubMenu(e, index2)}
                        className={`w-full flex pl-2 flex-col  justify-center space-y-3 ${open[index1]?.open ? 'hidden' : 'pl-2'} `}>
                        <div className={`flex flex-row justify-start  items-center  rounded-r-lg  px-2 cursor-pointer  h-10 hover:bg-secondary dark:hover:text-black"  ${subOpen[index2]?.isActive ? "border-l-4 border-blue-500" : ""}`}>
                          {obj1?.svg}
                          <div onClick={() => handleNavigate(obj1?.path)} className="primary-${color} text-sm dark:text-slate-200 dark:hover:text-black   flex flex-col w-auto justify-center items-end">
                            <span className="">{beginWord(obj1.label)}</span>
                            <span className="text-right text-xs italic">{endWord(obj1.label)}</span>
                          </div>
                        </div>
                        {obj1?.subMenu?.map((obj2: any, index3: any) => {
                          return <li
                            onClick={(e) => handleItems(e, index3)}
                            className={`w-full flex flex-col pl-2 justify-start space-y-3  ${subOpen[index2]?.open ? 'hidden' : 'ml-2'} `}>
                            <div className={`flex flex-row justify-start rounded-r-lg px-2 cursor-pointer h-10 items-center hover:bg-secondary dark:hover:text-black"  ${menuOpen[index3]?.isActive ? "border-l-4 border-blue-500" : ""}`}>
                              {obj2?.svg}
                              <div onClick={() => handleNavigate(obj2?.path)} className="text-sm dark:text-slate-200 dark:hover:text-black w-36 flex flex-col w-auto justify-center items-end">
                                <span className="">{beginWord(obj2.label)}</span>
                                <span className="text-right text-xs italic"> {endWord(obj2.label)}</span>
                              </div>
                            </div>
                          </li>
                        })}
                      </ul>
                    })}
                  </ul>
                </li>
              })}
            </ul>
          </div>
        </div>
        {/* <div
          onClick={() => setIsMore(!isMore)}
          className="w-24 text-xs text-right px-4 text-blue-500 underline cursor-pointer">
          {!isMore ? 'More' : 'Less'}
        </div> */}
      </div>}
    </>
  )
}

export default Sidebar;